import React from 'react';
import AiSearchProfileDialog from '../AiSearchProfilePopout/AiSearchProfileDialog';
import ShortlistedHeader from './ShortlistedHeader';
import ShortlistedList from './ShortlistedList';
import { ShortlistedTableContext, useShortlistedTableContextProvider } from './utils/ShortlistedTableContext';
import EmailCandidateDialog from './Outreach/EmailCandidateFormDialog/EmailCandidateDialog';
import LinkedInMessageDialog from './Outreach/LinkedInMessage/LinkedInMessageDialog';

const ShortlistedPageContent = () => {
    return (
        <ShortlistedTableContext.Provider value={useShortlistedTableContextProvider()}>
            <AiSearchProfileDialog />
            <LinkedInMessageDialog />
            <EmailCandidateDialog />
            <ShortlistedHeader />
            <ShortlistedList />
        </ShortlistedTableContext.Provider>
    );
};

export default ShortlistedPageContent;
